module.exports = __webpack_public_path__ + "static/media/Twitter.7d6e19be.svg";